import { staffSearchPath, hasNewPlacementFlow } from "@helpers/staffSearchHelpers"

// Shared one-click actions available from every page. These are merged into
// `pageContext.actions` by PageContextProvider, so any page-specific actions
// declared via <PageContextSetter actions={...} /> are layered on top.
//
// Keep this list to pure, no-argument navigation. Anything that needs page
// state (opening a modal, filtering a local list) belongs on the page itself.
//
// `user` is used to route staff search to the new page when the new placement
// flow is on (see staffSearchPath).
export const buildSharedPageActions = (history, user) => ({
  viewDashboard: {
    description: "Navigate to the home dashboard",
    label: "View dashboard",
    handler: () => history.push("/")
  },
  // The legacy watchlist is being phased out (PCD-588); new placement flow
  // users get the private shortlist instead, so the quick action is hidden.
  ...(hasNewPlacementFlow(user)
    ? {}
    : {
        viewWatchlist: {
          description: "View the watchlist of candidates",
          label: "View watchlist",
          handler: () => history.push("/placements/watchlist")
        }
      }),
  viewOnReviewPlacements: {
    description: "View placements that are on review (employer needs to make an offer)",
    label: "View on-review placements",
    handler: () => history.push("/placements/on_review")
  },
  viewConfirmedPlacements: {
    description: "View confirmed placements",
    label: "View confirmed placements",
    handler: () => history.push("/placements/confirmed")
  },
  viewPlacedPlacements: {
    description: "View placed candidates (those who have arrived)",
    label: "View placed candidates",
    handler: () => history.push("/placements/placed")
  },
  viewStaffingNeeds: {
    description: "View the staffing needs list (open roles)",
    label: "View staffing needs",
    handler: () => history.push("/staffing-needs")
  },
  addStaffingNeed: {
    description: "Open the form to add a new staffing need (a role to fill)",
    label: "Add a staffing need",
    handler: () => history.push("/staffing-needs/new")
  },
  searchStaff: {
    description: "Search for staff / candidates",
    label: "Search staff",
    handler: () => history.push(staffSearchPath(user))
  },
  viewDocuments: {
    description: "View the documents list (uploads required and downloads available)",
    label: "View documents",
    handler: () => history.push("/documents")
  },
  viewFinancials: {
    description: "View the financials page (statements, invoices, payments)",
    label: "View financials",
    handler: () => history.push("/financials")
  },
  viewArrivals: {
    description: "View staff arrivals",
    label: "View arrivals",
    handler: () => history.push("/arrivals")
  },
  viewArrivalDates: {
    description: "View arrival dates",
    label: "View arrival dates",
    handler: () => history.push("/arrival-dates")
  },
  viewAgreements: {
    description: "View agreements",
    label: "View agreements",
    handler: () => history.push("/agreements")
  },
  viewContacts: {
    description: "View contacts",
    label: "View contacts",
    handler: () => history.push("/contacts")
  },
  viewStaffRatings: {
    description: "View feedback / staff ratings",
    label: "View feedback",
    handler: () => history.push("/staff-ratings")
  }
})
